import { render, staticRenderFns } from "./Lineup.vue?vue&type=template&id=72165b5b&scoped=true&"
import script from "./Lineup.vue?vue&type=script&lang=ts&"
export * from "./Lineup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72165b5b",
  null
  
)

export default component.exports